import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToolbarPlane = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M5.1 2.80001C5.1 1.52975 4.07025 0.500006 2.8 0.500006C1.52974 0.500006 0.5 1.52975 0.5 2.80001C0.5 4.07026 1.52974 5.10001 2.8 5.10001C4.07025 5.10001 5.1 4.07026 5.1 2.80001Z",
			stroke: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5 2.80001C13.5 1.52975 12.4703 0.500007 11.2 0.500007C9.92977 0.500007 8.90002 1.52975 8.90002 2.80001C8.90002 4.07026 9.92977 5.10001 11.2 5.10001C12.4703 5.10001 13.5 4.07026 13.5 2.80001Z",
			stroke: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5 11.2C13.5 9.92975 12.4703 8.9 11.2 8.9C9.92977 8.9 8.90002 9.92975 8.90002 11.2C8.90002 12.4703 9.92977 13.5 11.2 13.5C12.4703 13.5 13.5 12.4703 13.5 11.2Z",
			stroke: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.03382 2.25C5.07707 2.42623 5.1 2.61044 5.1 2.8C5.1 2.954 5.08486 3.10447 5.056 3.25H8.94403C8.91516 3.10447 8.90002 2.954 8.90002 2.8C8.90002 2.61044 8.92296 2.42623 8.9662 2.25H5.03382Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.75 5.03383C11.5738 5.07707 11.3896 5.1 11.2 5.1C11.046 5.1 10.8955 5.08486 10.75 5.05599V8.944C10.8955 8.91513 11.046 8.89999 11.2 8.89999C11.3896 8.89999 11.5738 8.92293 11.75 8.96616V5.03383Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.9662 11.75C8.92296 11.5738 8.90002 11.3896 8.90002 11.2C8.90002 11.046 8.91516 10.8955 8.94403 10.75H3.25V5.056C3.10447 5.08486 2.954 5.1 2.8 5.1C2.61044 5.1 2.42623 5.07707 2.25 5.03382V11.75H8.9662Z",
			fill: "white"
		})
	]
});
export default SvgToolbarPlane;
